import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

import { FilterDropdown } from "/imports/ui/components/shared";
import { SECTION_LABEL_SX, CARD_SX } from "/imports/ui/components/booking";

function ClassFilterSidebar({ cls }) {
  const {
    filters,
    setFilter,
    availableSports,
    locationFilteredServices,
    serviceLocations,
    availableTrainers,
    availableAges,
    levelFilterAvailable,
    levelOptions,
    levelScope,
    levelValue,
    setLevelScope,
    canApplyPreferences,
    applyPreferences,
    handleSportChange
  } = cls;

  return (
    <Box sx={{ width: "17.5rem", flexShrink: 0, position: "sticky", top: 88 }}>
      <Paper elevation={0} sx={{ ...CARD_SX, p: 2.5, display: "flex", flexDirection: "column", gap: 2.25 }}>
        {canApplyPreferences && (
          <Button
            fullWidth
            variant="outlined"
            size="small"
            startIcon={<AutoAwesomeIcon sx={{ fontSize: "1rem" }} />}
            onClick={applyPreferences}
            sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}
          >
            Use my preferences
          </Button>
        )}

        {availableSports.length > 1 && (
          <Box>
            <Typography sx={SECTION_LABEL_SX}>Sport</Typography>
            <FilterDropdown
              options={availableSports.map((s) => ({ value: s._id, label: s.name }))}
              value={filters.sport}
              onChange={(val) => handleSportChange(val)}
              allLabel="All Sports"
              active={!!filters.sport}
              fullWidth
            />
          </Box>
        )}

        <Box>
          <Typography sx={SECTION_LABEL_SX}>Class</Typography>
          <FilterDropdown
            options={locationFilteredServices.map((s) => ({ value: s._id, label: s.name }))}
            value={filters.serviceId}
            onChange={(val) => setFilter("serviceId", val)}
            allLabel="All Classes"
            active={!!filters.serviceId}
            fullWidth
          />
        </Box>

        {levelFilterAvailable && (
          <Box>
            <Typography sx={SECTION_LABEL_SX}>Level</Typography>
            <FilterDropdown
              options={levelOptions}
              value={levelValue}
              onChange={setLevelScope}
              allLabel="All Levels"
              active={levelScope === "mine"}
              fullWidth
            />
          </Box>
        )}

        {serviceLocations.length > 0 && (
          <Box>
            <Typography sx={SECTION_LABEL_SX}>Location</Typography>
            <FilterDropdown
              options={serviceLocations.map((l) => ({ value: l._id, label: l.name }))}
              value={filters.locationId}
              onChange={(val) => setFilter("locationId", val)}
              allowAll={serviceLocations.length > 1}
              allLabel="All Locations"
              active={!!filters.locationId}
              fullWidth
            />
          </Box>
        )}

        {availableTrainers.length > 0 && (
          <Box>
            <Typography sx={SECTION_LABEL_SX}>Trainer</Typography>
            <FilterDropdown
              options={availableTrainers.map((t) => ({ value: t._id, label: t.name }))}
              value={filters.trainerId}
              onChange={(val) => setFilter("trainerId", val)}
              allLabel="All Trainers"
              active={!!filters.trainerId}
              fullWidth
            />
          </Box>
        )}

        {availableAges.length > 1 && (
          <Box>
            <Typography sx={SECTION_LABEL_SX}>Age & Gender</Typography>
            <FilterDropdown
              options={availableAges}
              value={filters.age}
              onChange={(val) => setFilter("age", val)}
              allLabel="No preference"
              active={!!filters.age}
              fullWidth
            />
          </Box>
        )}
      </Paper>
    </Box>
  );
}

export default ClassFilterSidebar;
